export const buildFormDataForAudioQualityCheck = ({
  audioForPitchAnalysis,
  audioForEffectsDetection,
  sweetSpot,
}: {
  audioForPitchAnalysis: File | null;
  // One part per analysed clip — the conversion check sends a single clip, the model check one clip per chunk of the training file.
  audioForEffectsDetection: Blob[];
  sweetSpot: { low: number; high: number } | null;
}): FormData => {
  const formData = new FormData();
  if (audioForPitchAnalysis !== null) {
    formData.append(
      "audio_for_pitch_analysis",
      audioForPitchAnalysis,
      audioForPitchAnalysis.name
    );
  }
  for (const audioForEffectsDetectionPart of audioForEffectsDetection) {
    formData.append(
      "audio_for_effects_detection",
      audioForEffectsDetectionPart,
      "audio-for-effects-detection.wav"
    );
  }
  if (sweetSpot !== null) {
    formData.append("sweetspot", JSON.stringify(sweetSpot));
  }
  return formData;
};
